import React from "react";
import classnames from "classnames";

const iconLayouts = color => ({
  viewProfile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4036 12.2865C10.4036 12.6953 10.566 13.0874 10.855 13.3765C11.1441 13.6655 11.5361 13.8279 11.9449 13.8279C12.3537 13.8279 12.7458 13.6655 13.0349 13.3765C13.3239 13.0874 13.4863 12.6953 13.4863 12.2865C13.4863 11.8777 13.3239 11.4857 13.0349 11.1966C12.7458 10.9076 12.3537 10.7452 11.9449 10.7452C11.5361 10.7452 11.1441 10.9076 10.855 11.1966C10.566 11.4857 10.4036 11.8777 10.4036 12.2865ZM17.9205 11.9315C16.6159 9.18316 14.6437 7.80005 12 7.80005C9.35489 7.80005 7.38413 9.18316 6.07947 11.9329C6.02714 12.0437 6 12.1647 6 12.2872C6 12.4098 6.02714 12.5308 6.07947 12.6416C7.38413 15.3899 9.35627 16.773 12 16.773C14.6451 16.773 16.6159 15.3899 17.9205 12.6402C18.0265 12.4173 18.0265 12.1586 17.9205 11.9315ZM11.9449 14.7087C10.6073 14.7087 9.52279 13.6242 9.52279 12.2865C9.52279 10.9489 10.6073 9.86439 11.9449 9.86439C13.2826 9.86439 14.3671 10.9489 14.3671 12.2865C14.3671 13.6242 13.2826 14.7087 11.9449 14.7087Z"
        fill={color}
      />
      <circle cx="12" cy="12" r="11.5" stroke={color} />
    </svg>
  ),
  clock: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9933 1.33337C4.3133 1.33337 1.3333 4.32004 1.3333 8.00004C1.3333 11.68 4.3133 14.6667 7.9933 14.6667C11.68 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.68 1.33337 7.9933 1.33337ZM7.99997 13.3334C5.0533 13.3334 2.66663 10.9467 2.66663 8.00004C2.66663 5.05337 5.0533 2.66671 7.99997 2.66671C10.9466 2.66671 13.3333 5.05337 13.3333 8.00004C13.3333 10.9467 10.9466 13.3334 7.99997 13.3334ZM7.8533 4.66671H7.8133C7.54664 4.66671 7.3333 4.88004 7.3333 5.14671V8.29337C7.3333 8.52671 7.4533 8.74671 7.65997 8.86671L10.4266 10.5267C10.6533 10.66 10.9466 10.5934 11.08 10.3667C11.1134 10.3127 11.1357 10.2526 11.1454 10.1898C11.1552 10.127 11.1522 10.0629 11.1366 10.0014C11.1211 9.93977 11.0933 9.88194 11.0549 9.83132C11.0166 9.7807 10.9684 9.73832 10.9133 9.70671L8.3333 8.17337V5.14671C8.3333 4.88004 8.11997 4.66671 7.8533 4.66671Z"
        fill={color}
      />
    </svg>
  ),
  bars: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7.34L2 7.33333V8.66667H14V7.34ZM2 10.6667H10V12H2V10.6667ZM14 4H2V5.34L14 5.33333V4Z"
        fill={color}
      />
    </svg>
  ),
  leftArrow: (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.54282 0.542969L8.95703 1.95718L3.16414 7.75008L8.95703 13.543L7.54282 14.9572L0.335711 7.75008L7.54282 0.542969Z"
        fill="var(--pallet-color)"
      />
    </svg>
  ),
  rightArrow: (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.45718 14.957L0.0429687 13.5428L5.83586 7.74992L0.0429682 1.95703L1.45718 0.542818L8.66429 7.74992L1.45718 14.957Z"
        fill="var(--pallet-color)"
      />
    </svg>
  ),
  tag: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.736367 11.3846L10.8453 1.27564C11.2531 0.867833 11.8171 0.655919 12.3926 0.694282L18.1486 1.07802C19.6483 1.17799 20.8425 2.37221 20.9424 3.87182L21.3262 9.62789C21.3645 10.2033 21.1526 10.7673 20.7448 11.1751L10.6359 21.2841C9.85481 22.0652 8.58848 22.0652 7.80743 21.2841L0.736367 14.213C-0.0446814 13.432 -0.0446813 12.1657 0.736367 11.3846ZM2.15058 12.7988L9.22165 19.8699L19.3306 9.76093L18.9469 4.00486C18.9135 3.50499 18.5155 3.10692 18.0156 3.07359L12.2595 2.68986L2.15058 12.7988ZM15.5856 6.43487C16.3667 7.21592 16.3667 8.48226 15.5856 9.26331C14.8046 10.0444 13.5382 10.0444 12.7572 9.2633C11.9761 8.48226 11.9761 7.21592 12.7572 6.43487C13.5382 5.65383 14.8046 5.65382 15.5856 6.43487Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="5.13743"
          y1="17.9878"
          x2="21.7383"
          y2="3.90001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF872C" />
          <stop offset="1" stop-color="#FFA709" />
        </linearGradient>
      </defs>
    </svg>
  ),
  users: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1212 18.7455C19.679 17.6983 19.0374 16.747 18.2321 15.9447C17.4292 15.1401 16.4781 14.4986 15.4313 14.0557C15.4219 14.051 15.4126 14.0486 15.4032 14.0439C16.8633 12.9893 17.8126 11.2713 17.8126 9.33301C17.8126 6.12207 15.211 3.52051 12.0001 3.52051C8.78912 3.52051 6.18756 6.12207 6.18756 9.33301C6.18756 11.2713 7.13678 12.9893 8.59693 14.0463C8.58756 14.051 8.57818 14.0533 8.56881 14.058C7.51881 14.501 6.57662 15.1361 5.76803 15.9471C4.96344 16.75 4.32194 17.7011 3.87896 18.7479C3.44378 19.7727 3.20908 20.8714 3.18756 21.9846C3.18693 22.0096 3.19132 22.0345 3.20046 22.0578C3.20961 22.0811 3.22332 22.1023 3.24079 22.1202C3.25826 22.1381 3.27915 22.1523 3.30221 22.1621C3.32527 22.1718 3.35004 22.1768 3.37506 22.1768H4.78131C4.88443 22.1768 4.96646 22.0947 4.96881 21.9939C5.01568 20.1846 5.74225 18.49 7.02662 17.2057C8.35553 15.8768 10.1204 15.1455 12.0001 15.1455C13.8797 15.1455 15.6446 15.8768 16.9735 17.2057C18.2579 18.49 18.9844 20.1846 19.0313 21.9939C19.0337 22.0971 19.1157 22.1768 19.2188 22.1768H20.6251C20.6501 22.1768 20.6749 22.1718 20.6979 22.1621C20.721 22.1523 20.7419 22.1381 20.7593 22.1202C20.7768 22.1023 20.7905 22.0811 20.7997 22.0578C20.8088 22.0345 20.8132 22.0096 20.8126 21.9846C20.7891 20.8643 20.5571 19.7744 20.1212 18.7455ZM12.0001 13.3643C10.9243 13.3643 9.91178 12.9447 9.15006 12.183C8.38834 11.4213 7.96881 10.4088 7.96881 9.33301C7.96881 8.25723 8.38834 7.24473 9.15006 6.48301C9.91178 5.72129 10.9243 5.30176 12.0001 5.30176C13.0758 5.30176 14.0883 5.72129 14.8501 6.48301C15.6118 7.24473 16.0313 8.25723 16.0313 9.33301C16.0313 10.4088 15.6118 11.4213 14.8501 12.183C14.0883 12.9447 13.0758 13.3643 12.0001 13.3643Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="3.90203"
          y1="12.9327"
          x2="20.8126"
          y2="12.9327"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF872C" />
          <stop offset="1" stop-color="#FFA709" />
        </linearGradient>
      </defs>
    </svg>
  ),
  time: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10ZM9 5C9 4.44772 9.44771 4 10 4C10.5523 4 11 4.44772 11 5V9.63603L13.98 13.1874C14.335 13.6105 14.2798 14.2413 13.8567 14.5963C13.4337 14.9513 12.8029 14.8961 12.4479 14.473L9.23804 10.6477C9.1933 10.5951 9.1539 10.5378 9.12069 10.4767C9.06608 10.3761 9.02821 10.2652 9.01081 10.1476C9.00325 10.0965 8.99965 10.045 9 9.99366M9 5V9.99366V5Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0.810811"
          y1="10.0901"
          x2="20"
          y2="10.0901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF872C" />
          <stop offset="1" stop-color="#FFA709" />
        </linearGradient>
      </defs>
    </svg>
  ),
  appointmentBook: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M61.9583 0.5C65.5498 0.5 68.9942 1.92671 71.5337 4.46626C74.0733 7.00582 75.5 10.4502 75.5 14.0417V17.1667H0.5V14.0417C0.5 10.4502 1.92671 7.00582 4.46626 4.46626C7.00582 1.92671 10.4502 0.5 14.0417 0.5H61.9583Z"
        fill="#707070"
      />
      <path
        d="M75.5 23.4165V38.0915C70.2999 34.7657 64.1197 33.316 57.9831 33.9826C51.8465 34.6492 46.1217 37.392 41.7569 41.7568C37.3922 46.1215 34.6493 51.8463 33.9828 57.9829C33.3162 64.1195 34.7659 70.2997 38.0917 75.4998H14.0417C10.4502 75.4998 7.00582 74.0731 4.46626 71.5336C1.92671 68.994 0.5 65.5496 0.5 61.9582V23.4165H75.5Z"
        fill="#707070"
      />
      <path
        d="M83.8333 60.9167C83.8333 54.8388 81.4189 49.0098 77.1212 44.7121C72.8235 40.4144 66.9945 38 60.9167 38C54.8388 38 49.0098 40.4144 44.7121 44.7121C40.4144 49.0098 38 54.8388 38 60.9167C38 66.9945 40.4144 72.8235 44.7121 77.1212C49.0098 81.4189 54.8388 83.8333 60.9167 83.8333C66.9945 83.8333 72.8235 81.4189 77.1212 77.1212C81.4189 72.8235 83.8333 66.9945 83.8333 60.9167ZM60.9167 60.9167H69.25C69.8025 60.9167 70.3324 61.1362 70.7231 61.5269C71.1138 61.9176 71.3333 62.4475 71.3333 63C71.3333 63.5525 71.1138 64.0824 70.7231 64.4731C70.3324 64.8638 69.8025 65.0833 69.25 65.0833H58.8333C58.2808 65.0833 57.7509 64.8638 57.3602 64.4731C56.9695 64.0824 56.75 63.5525 56.75 63V50.5C56.75 49.9475 56.9695 49.4176 57.3602 49.0269C57.7509 48.6362 58.2808 48.4167 58.8333 48.4167C59.3859 48.4167 59.9158 48.6362 60.3065 49.0269C60.6972 49.4176 60.9167 49.9475 60.9167 50.5V60.9167Z"
        fill="#707070"
      />
    </svg>
  ),
  appointmentCancelled: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.9167 38C66.9945 38 72.8235 40.4144 77.1212 44.7121C81.4189 49.0098 83.8333 54.8388 83.8333 60.9167C83.8333 66.9945 81.4189 72.8235 77.1212 77.1212C72.8235 81.4189 66.9945 83.8333 60.9167 83.8333C54.8388 83.8333 49.0098 81.4189 44.7121 77.1212C40.4144 72.8235 38 66.9945 38 60.9167C38 54.8388 40.4144 49.0098 44.7121 44.7121C49.0098 40.4144 54.8388 38 60.9167 38ZM50.6 50.6C50.2094 50.9907 49.99 51.5205 49.99 52.0729C49.99 52.6253 50.2094 53.1551 50.6 53.5458L57.9708 60.9208L50.6083 68.2792C50.4146 68.4726 50.2609 68.7023 50.156 68.9551C50.0511 69.2079 49.9969 69.479 49.9968 69.7527C49.9966 70.0264 50.0503 70.2975 50.1549 70.5505C50.2594 70.8035 50.4128 71.0334 50.6063 71.2271C50.7997 71.4208 51.0294 71.5745 51.2822 71.6794C51.535 71.7844 51.806 71.8385 52.0798 71.8387C52.3535 71.8389 52.6246 71.7851 52.8776 71.6805C53.1306 71.576 53.3605 71.4226 53.5542 71.2292L60.9167 63.8667L68.2917 71.2375C68.4838 71.4365 68.7137 71.5952 68.9679 71.7044C69.2221 71.8136 69.4955 71.871 69.7721 71.8734C70.0487 71.8758 70.323 71.8231 70.5791 71.7184C70.8351 71.6136 71.0677 71.4589 71.2633 71.2633C71.4589 71.0677 71.6136 70.8351 71.7184 70.5791C71.8231 70.323 71.8758 70.0487 71.8734 69.7721C71.871 69.4955 71.8136 69.2221 71.7044 68.9679C71.5952 68.7137 71.4365 68.4838 71.2375 68.2917L63.8667 60.9167L71.2458 53.5417C71.6253 53.1487 71.8353 52.6225 71.8306 52.0762C71.8258 51.53 71.6067 51.0075 71.2205 50.6212C70.8342 50.2349 70.3117 50.0158 69.7654 50.0111C69.2192 50.0063 68.6929 50.2163 68.3 50.5958L60.9208 57.9708L53.5458 50.5958C53.1551 50.2053 52.6253 49.9859 52.0729 49.9859C51.5205 49.9859 50.9907 50.2053 50.6 50.5958V50.6ZM75.5 23.4167L75.5042 38.0958C70.3037 34.7661 64.1216 33.3135 57.9825 33.9788C51.8434 34.6441 46.1159 37.3872 41.7495 41.7537C37.3831 46.1201 34.6399 51.8475 33.9746 57.9867C33.3093 64.1258 34.762 70.3079 38.0917 75.5083L14.0417 75.5C10.4502 75.5 7.00582 74.0733 4.46626 71.5337C1.92671 68.9942 0.5 65.5498 0.5 61.9583V23.4167H75.5ZM61.9583 0.5C65.5498 0.5 68.9942 1.92671 71.5337 4.46626C74.0733 7.00582 75.5 10.4502 75.5 14.0417V17.1667H0.5V14.0417C0.5 10.4502 1.92671 7.00582 4.46626 4.46626C7.00582 1.92671 10.4502 0.5 14.0417 0.5H61.9583Z"
        fill="#707070"
      />
    </svg>
  ),
  dashCircle: (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.5" cy="17.5" r="17" stroke="var(--icon-color)" />
      <circle
        cx="18"
        cy="18"
        r="9.5"
        fill="var(--icon-color)"
        stroke="var(--icon-color)"
      />
      <path d="M9.71436 24L26.2858 12" stroke="white" stroke-width="2" />
    </svg>
  ),
  documentIcon: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6665 14.9997V5.83301L30.8332 14.9997H21.6665ZM9.99984 3.33301C8.14984 3.33301 6.6665 4.81634 6.6665 6.66634V33.333C6.6665 34.2171 7.01769 35.0649 7.64281 35.69C8.26794 36.3152 9.11578 36.6663 9.99984 36.6663H29.9998C30.8839 36.6663 31.7317 36.3152 32.3569 35.69C32.982 35.0649 33.3332 34.2171 33.3332 33.333V13.333L23.3332 3.33301H9.99984Z"
        fill={color}
      />
    </svg>
  ),
  documentIconAfterCall: (
    <svg
      width="34"
      height="34"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.6665 14.9997V5.83301L30.8332 14.9997H21.6665ZM9.99984 3.33301C8.14984 3.33301 6.6665 4.81634 6.6665 6.66634V33.333C6.6665 34.2171 7.01769 35.0649 7.64281 35.69C8.26794 36.3152 9.11578 36.6663 9.99984 36.6663H29.9998C30.8839 36.6663 31.7317 36.3152 32.3569 35.69C32.982 35.0649 33.3332 34.2171 33.3332 33.333V13.333L23.3332 3.33301H9.99984Z"
        fill={color}
      />
    </svg>
  ),
  cancel: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM11 19.25C6.4625 19.25 2.75 15.5375 2.75 11C2.75 6.4625 6.4625 2.75 11 2.75C15.5375 2.75 19.25 6.4625 19.25 11C19.25 15.5375 15.5375 19.25 11 19.25Z"
        fill={color}
      />
      <path
        d="M14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
        fill={color}
      />
    </svg>
  ),
  chat: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 14.375C12.7613 14.375 15 12.4162 15 10C15 7.58375 12.7613 5.625 10 5.625C7.23875 5.625 5 7.58375 5 10C5 11.1 5.46438 12.1063 6.23125 12.875C6.17062 13.51 5.97062 14.2063 5.74937 14.7288C5.7 14.845 5.79562 14.975 5.92 14.955C7.33 14.7238 8.16812 14.3688 8.5325 14.1838C9.01119 14.3114 9.50457 14.3757 10 14.375Z"
        fill={color}
      />
      <circle cx="10" cy="10" r="9.5" stroke={color} />
    </svg>
  ),
  plus: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1.5V16.5M1.5 9H16.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  msgSend: (
    <svg
      width="33"
      height="33"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill={color} />
      <path
        d="M22.6892 6.68923L14.6505 24.1064L12.6409 16.7376L5.27208 14.7279L22.6892 6.68923Z"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <line
        x1="22.0381"
        y1="7.37772"
        x2="12.6597"
        y2="16.7562"
        stroke="white"
      />
    </svg>
  ),
});

const AppointmentIcon = ({ onClick, className, type, color }) => {
  const icon = iconLayouts(color || "var(--icon-color)")[type];
  return (
    <span className={classnames("mr-2", className)} onClick={onClick}>
      {icon}
    </span>
  );
};

export default AppointmentIcon;
